import { breakpoints, Button, Dialog, Inline, Stack, Text } from '@etg/wings';
import { useDirection, useTranslation } from '@eti/providers';
import { Illustration } from '@eti/components';
import { Link } from 'react-router-dom';
import { routes } from '../../constants/routesAndApisConstants';

interface SessionExpiredDialogProps {
  brandCode: string;
  isOpen: boolean;
  handleOpenSessionExpiredDialog: (a: boolean) => void;
}

const UnauthSessionExpiredDialog = ({
  brandCode,
  handleOpenSessionExpiredDialog,
  isOpen,
}: SessionExpiredDialogProps) => {
  const { t } = useTranslation();
  const { isRTL } = useDirection();

  return (
    <Dialog
      closeButtonAriaLabel={t('ScreenReader.CloseButtonDialog.AriaLabel.Text')}
      data-testid="expired-session-dialog"
      illustration={<Illustration brand={brandCode} id="reload" mirrored={isRTL} />}
      isOpen={isOpen}
      title={t('IbeClient.UnauthSessionExpired.Modal.Title')}
    >
      <Stack>
        <Text>{t('IbeClient.UnauthSessionExpired.Modal.Description')}</Text>
        <Inline align="end" collapseBelow={breakpoints._560} spacing={8}>
          <Button
            as={Link}
            data-testid="back-to-search-button"
            onClick={() => handleOpenSessionExpiredDialog(false)}
            to={routes.START}
            variant="primary"
          >
            {t('IbeClient.UnauthSessionExpired.Modal.Button')}
          </Button>
        </Inline>
      </Stack>
    </Dialog>
  );
};

export default UnauthSessionExpiredDialog;
